export enum enOrderBumpStatusBase {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived'
}

export enum enOrderBumpStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ERROR = 'error',
  ARCHIVED = 'archived',
  REMOVED = 'removed',
  WARNING = 'warning'
}
